import { Dialog, DialogContent } from "@mui/material";
import LoadingFechamento from "../DialogDetalheFechamento/LoadingFechamento";
import { enqueueSnackbar } from "notistack";

interface DialogDetalheFechandoProps {
    open: boolean;
    onClose: () => void;
    id: number;
}

export default function DialogDetalheFechando({ open, onClose, id }: DialogDetalheFechandoProps) {


    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogContent>
                <LoadingFechamento id={id} label="Em andamento" onFechado={() => {
                    onClose()
                    enqueueSnackbar("Fechamento finalizado com sucesso", { variant: "success" })
                }} />
            </DialogContent>
        </Dialog>
    );
} 